import api from "./ApiService";
import {
  getAccessToken,
  getAuthHeaders,
  setTokens,
  clearSession,
  hasValidSession
} from "../utils/authStorage";

export default {
  getSessionToken() {
    return getAccessToken();
  },

  getSessionHeaders() {
    return getAuthHeaders();
  },

  deleteSession() {
    clearSession();
  },

  hasValidSession() {
    return hasValidSession();
  },

  validateSession() {
    return api.get("/customers/profile");
  },

  login(loginCredentials) {
    return api.post("/auth/login", loginCredentials).then((response) => {
      // Store tokens on successful login
      if (response.data?.token) {
        setTokens(response.data);
      }
      return response;
    });
  },

  logout() {
    clearSession();
  },
};
